"use strict";
angular.module("planCommandMonitorServiceModule", ['planCommandMonitorShareModule','planCommandMonitorEditSignedArticleModule'])
    .factory("planCommandMonitorService", ['$modal','$q', function($modal,$q) {
        return {
            /**
             * [share description] 分享的弹框
             * @param  {[type]} item    [description] 分享的数据
             * @param  {[type]} confirmBtn    [description] 按钮名
             * @param  {[type]} success [description] 分享成功的回调函数
             * @return {[type]}         [description]
             */
            share: function(id, type, confirmBtn, success) {
                var modalInstance = $modal.open({
                    templateUrl: "./planningResource/commandMonitor/service/share/share_tpl.html",                                   
                    windowClass: "share_confirm_window",
                    backdrop: false,
                    controller: "planCommandMonitorShareCtrl",
                    resolve: {
                        item: function() {
                            return {
                                id: id,
                                type: type
                            };
                        },
                        confirmBtn: function() {
                            return confirmBtn;
                        }
                    }
                });
                modalInstance.result.then(function(data) {
                    if (angular.isFunction(success)) {
                        success(data);
                    }
                });
            },
            /**
             * [editSignedArticle description] 更改标志文章
             * @param  {[type]} item    [description] 标志文章
             * @param  {[type]} success [description] 确认的回调
             * @return {[type]}         [description]
             */
            editSignedArticle: function(title, content, confirmBtn, cancelBtn, guidValue, success, cancel) {
                var modalInstance = $modal.open({
                    templateUrl: "./planningResource/commandMonitor/service/editSignedArticle/editSignedArticle_tpl.html",
                    windowClass: "plan-commandMonitor-editSignedArticle",
                    backdrop: false,
                    controller: "planCommandMonitorEditSignedArticleCtrl",
                    resolve: {
                        item: function() {
                            return {
                                title: title,
                                content: content,
                                confirmBtn: confirmBtn,
                                cancelBtn: cancelBtn,
                                guidValue: guidValue
                            };
                        }
                    }
                });
                modalInstance.result.then(function(data) {
                    if (data !== undefined) {
                        if (angular.isFunction(success)) {
                            success(data);
                        }
                    } else {
                        if (angular.isFunction(cancel)) {
                            cancel(data);
                        }
                    }
                });
            },
            newBeforeSelectTop:function(value){
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningResource/commandMonitor/beforeSelectTopic/newBeforeSelectTopic/newBeforeSelectTopic_tpl.html",
                    windowClass: "newBeforeSelectTopicCl",
                    backdrop: false,
                    controller: "planCommandMonitorBeforeSelectTopicCompileCtrl",
                    resolve: {
                        itemData:function(){
                            return {
                                datas:value
                            }
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
            },
            newAddCustomFuncMana:function(value){
                var modalInstance = $modal.open({
                    templateUrl: "./planningResource/commandMonitor/customFuncManage/customFuncCompile/customFuncCompile_tpl.html",
                    windowClass: "newAddCustomFuncMana_window",
                    backdrop: false,
                    controller: "planCommandMonitorCustomFuncComplieCtrl",
                    resolve: {
                        itemData:function(){
                            return {
                                datas:value
                            }
                        }
                    }
                });
                modalInstance.result.then(function() {

                });
            },
            functionListShareLink:function(id, type, confirmBtn) {
                var modalInstance = $modal.open({
                    templateUrl: "./planningResource/commandMonitor/publicOpinionMgrZj/functionList/service/shareLink/shareLink_tpl.html",
                    windowClass: "shareLink",
                    backdrop: false,
                    controller: "shareLinkCtrl",
                    resolve: {
                        item: function() {
                            return {
                                id: id,
                                type: type
                            };
                        },
                        confirmBtn: function() {
                            return confirmBtn;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                });
            },
            regionRelevantArticles:function(transmitSearch,info,hot_type) {
                var modalInstance = $modal.open({
                    templateUrl: "./planningResource/commandMonitor/regionalHotspots/regionalHotspotsRelatedArticle/regionalHotspotsRelatedArticle_tpl.html",
                    windowClass: "regionRelevantArticlesClass",
                    backdrop: false,
                    controller: "planCommandMonitorRegionalHotspotsRelateArticleCtrl",
                    resolve: {
                        item: function() {
                            return {
                                transmitSearch:transmitSearch,
                                info:info,
                                hot_type:hot_type
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                });
            }
        }
    }]);